<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div>
		<!-- App Key name -->
		<mat-form-field appearance="standard" class="col-12 px-1" *ngIf="enableName">
			<mat-label i18n>App reference name</mat-label>
			<input matInput type="text" placeholder="My app" i18n-placeholder formControlName="name" />
			<mat-error
				appFormErrorMessage
				[type]="formEditorInputType.text"
				[errorFormControl]="formInputs.controls.name"
			></mat-error>
		</mat-form-field>
		<!-- END App Key name -->

		<!-- App Key Client ID -->
		<mat-form-field appearance="standard" class="col-12 px-1 hover-suffix">
			<mat-label i18n>Key</mat-label>
			<input matInput type="text" placeholder="-" i18n-placeholder value="{{ appKey.clientId }}" disabled/>
			<mat-icon
				class="suffix-icon"
				matSuffix
				matTooltip="Keep your Access Key in a secure place. Do not make it publicly available."
				i18n-matTooltip
			>info</mat-icon>
			<button
				class="suffix-icon"
				mat-icon-button
				type="button"
				title="Copy to clipboard"
				[appCopyToClipboard]="appKey.clientId"
				i18n-title
				matSuffix
			>
				<span class="material-icons">content_copy</span>
			</button>
		</mat-form-field>
		<!-- END App Key Client ID -->

		<div class="row px-1">
			<!-- Refresh token expiration -->
			<div class="col-6 col-sm-auto mb-2" *ngIf="appKey.provider == appKeyProviders.cognito">
				<label class="mb-0" i18n class="d-block">
					Refresh token expiration
					<mat-icon
						class="info-icon"
						aria-hidden="false"
						aria-label="icon displays a tooltip when focused or hovered over"
						matTooltip="Refresh token TTL must be between 60 minutes and 3650 days."
						i18n-matTooltip
					>info</mat-icon>
				</label>
				<mat-form-field appearance="standard" class="col-6 pr-2 pl-0" style="max-width: 60px;">
					<mat-label i18n>Days</mat-label>
					<input matInput type="number" min="0" max="3650" formControlName="refreshTokenValidityDays" [errorStateMatcher]="errorStateMatcher" />
				</mat-form-field>
				<mat-form-field appearance="standard" class="col-6 pr-2 pl-0" style="max-width: 60px;">
					<mat-label i18n>Minutes</mat-label>
					<input matInput type="number" min="0" [max]="3650 * 24 * 60" formControlName="refreshTokenValidityMinutes" [errorStateMatcher]="errorStateMatcher" />
				</mat-form-field>

				<mat-error
					*ngIf="formInputs.get('refreshTokenValidityDays').hasError('invalidTTL') || formInputs.get('refreshTokenValidityMinutes').hasError('invalidTTL')"
					i18n
					class="token__error"
				>Refresh token TTL must be between 60 minutes and 3650 days.</mat-error>
			</div>
			<!-- END Refresh token expiration -->

			<!-- Access token expiration -->
			<div class="col-6 col-sm-auto mb-2" *ngIf="appKey.provider == appKeyProviders.cognito">
				<label class="mb-0" i18n class="d-block">
					Access token expiration
					<mat-icon
						class="info-icon"
						aria-hidden="false"
						aria-label="icon displays a tooltip when focused or hovered over"
						matTooltip="Must be between 5 minutes and 1 day."
						i18n-matTooltip
					>info</mat-icon>
				</label>
				<mat-form-field appearance="standard" class="col-6 pr-2 pl-0" style="max-width: 60px;">
					<mat-label i18n>Days</mat-label>
					<input matInput type="number" min="0" max="1" formControlName="accessTokenValidityDays" [errorStateMatcher]="errorStateMatcher" />
				</mat-form-field>
				<mat-form-field appearance="standard" class="col-6 pr-2 pl-0" style="max-width: 60px;">
					<mat-label i18n>Minutes</mat-label>
					<input matInput type="number" min="0" [max]="24 * 60" formControlName="accessTokenValidityMinutes" [errorStateMatcher]="errorStateMatcher" />
				</mat-form-field>

				<mat-error
					*ngIf="formInputs.get('accessTokenValidityDays').hasError('invalidTTL') || formInputs.get('accessTokenValidityMinutes').hasError('invalidTTL')"
					i18n
					class="mb-4 token__error"
				>Access token TTL must be between 5 minutes and 1 day.</mat-error>

				<mat-error
					*ngIf="formInputs.get('accessTokenValidityDays').hasError('accessLargerThanRefreshTTL') || formInputs.get('accessTokenValidityMinutes').hasError('accessLargerThanRefreshTTL')"
					i18n
					class="mb-4 token__error"
				>Access token TTL cannot be greater than the refresh token expiration.</mat-error>
			</div>
			<!-- END Access token expiration -->
		</div>

		<!-- Verify email URL -->
		<mat-form-field appearance="standard" class="col-12 px-1 hover-suffix">
			<mat-label i18n>Verify Email Redirect URL</mat-label>
			<input matInput type="url" placeholder="URL" formControlName="emailVerifyUrl" />
			<mat-icon
				class="suffix-icon"
				matSuffix
				matTooltip="Optional redirect URL for email verification event."
				i18n-matTooltip
			>info</mat-icon>
			<button
				class="suffix-icon"
				matSuffix
				mat-icon-button
				type="button"
				[appCopyToClipboard]="formInputs.get('emailVerifyUrl').value"
				title="Copy to clipboard"
				i18n-title
				*ngIf="formInputs.get('emailVerifyUrl').value"
			>
				<span class="material-icons">content_copy</span>
			</button>
			<mat-error
				appFormErrorMessage
				[type]="formEditorInputType.url"
				[errorFormControl]="formInputs.controls.emailVerifyUrl"
			></mat-error>
		</mat-form-field>
		<!-- END Verify email URL -->

		<!-- Password reset URL -->
		<mat-form-field appearance="standard" class="col-12 px-1 hover-suffix">
			<mat-label i18n>Password Reset Redirect URL</mat-label>
			<input matInput type="url" placeholder="URL" formControlName="passwordResetUrl" />
			<mat-icon
				class="suffix-icon"
				matSuffix
				matTooltip="Optional redirect URL for password reset event."
				i18n-matTooltip
			>info</mat-icon>
			<button
				class="suffix-icon"
				matSuffix
				mat-icon-button
				type="button"
				[appCopyToClipboard]="formInputs.get('passwordResetUrl').value"
				title="Copy to clipboard"
				i18n-title
				*ngIf="formInputs.get('passwordResetUrl').value"
			>
				<span class="material-icons">content_copy</span>
			</button>
			<mat-error
				appFormErrorMessage
				[type]="formEditorInputType.url"
				[errorFormControl]="formInputs.controls.passwordResetUrl"
			></mat-error>
		</mat-form-field>
		<!-- END Password reset URL -->

		<!-- redirect URI -->
		<mat-form-field appearance="standard" class="col-12 px-1 hover-suffix">
			<mat-label i18n>OAuth Redirect URL</mat-label>
			<input matInput type="text" placeholder="Redirect URL" i18n-placeholder formControlName="redirectUri" />
			<button
				class="suffix-icon"
				matSuffix
				mat-icon-button
				type="button"
				[appCopyToClipboard]="formInputs.get('redirectUri').value"
				title="Copy to clipboard"
				i18n-title
				*ngIf="formInputs.get('redirectUri').value"
			>
				<span class="material-icons">content_copy</span>
			</button>
			<mat-error
				appFormErrorMessage
				[type]="formEditorInputType.url"
				[errorFormControl]="formInputs.controls.redirectUri"
			></mat-error>
		</mat-form-field>
		<!-- END Local redirect URI -->

		<!-- Signature Key -->
		<mat-form-field appearance="standard" class="col-12 px-1 mb-2 hover-suffix", *ngIf="false">
			<mat-label i18n>Signature Key</mat-label>
			<input matInput type="text" i18n-placeholder formControlName="sigSecret" />
			<mat-icon
				class="suffix-icon"
				matSuffix
				matTooltip="Used to calculate the signature hash for signing requests."
				i18n-matTooltip
			>info</mat-icon>
			<button
				class="suffix-icon"
				matSuffix
				mat-icon-button
				type="button"
				[appCopyToClipboard]="formInputs.get('sigSecret').value"
				title="Copy to clipboard"
				i18n-title
				*ngIf="formInputs.get('sigSecret').value"
			>
				<span class="material-icons">content_copy</span>
			</button>
			<mat-error
				appFormErrorMessage
				[type]="formEditorInputType.text"
				[errorFormControl]="formInputs.controls.sigSecret"
			></mat-error>
		</mat-form-field>
		<!-- END Signature Key -->

		<!-- Additional Features -->
		<div class="col-12 px-1 mb-3">
			<label class="w-100 mb-2" i18n>Additional Features</label>
			<ul class="list-unstyled checkbox-list">
				<li *ngIf="clusterFeaturesMask.denyLoginEmailUnverified && appKey.provider != appKeyProviders.gigya"><mat-checkbox
					formControlName="denyLoginEmailUnverified"
					i18n
					color="primary"
					class="text-wrap"
				>Prevent users from logging in if their email address is unverified.</mat-checkbox></li>
				<li *ngIf="clusterFeaturesMask.denyLoginUnacceptedTerms"><mat-checkbox
					formControlName="denyLoginUnacceptedTerms"
					i18n
					color="primary"
					class="text-wrap"
				>Prevent users from logging in unless they have accepted the App T&Cs.</mat-checkbox></li>
				<!-- Sub option of denyLoginUnacceptedTerms so use same logic for hiding/showing -->
				<li *ngIf="clusterFeaturesMask.refreshRequiresTerms"><mat-checkbox
					formControlName="refreshRequiresTerms"
					i18n
					color="primary"
					class="text-wrap"
				>Prevent users from refreshing the access token unless they have accepted the App T&Cs.</mat-checkbox></li>
				<!-- not supported -->
				<!-- <li *ngIf="clusterFeaturesMask.encryptJwt"><mat-checkbox
					formControlName="encryptJwt"
					i18n
					color="primary"
				>Encrypt JWT</mat-checkbox></li> -->
				<!-- <li *ngIf="clusterFeaturesMask.laxPasswordComplexity"><mat-checkbox
					formControlName="laxPasswordComplexity"
					i18n
					color="primary"
				>Lax Password Complexity</mat-checkbox></li> -->
				<li *ngIf="clusterFeaturesMask.haveIBeenPwnedPasswordComplexity && appKey.provider != appKeyProviders.entra"><mat-checkbox
					formControlName="haveIBeenPwnedPasswordComplexity"
					i18n
					color="primary"
					class="text-wrap"
				>Disable dynamic password complexity tests (ie HaveIBeenPwned).</mat-checkbox></li>
				<li *ngIf="clusterFeaturesMask.autoAcceptTerms"><mat-checkbox
					formControlName="autoAcceptTerms"
					i18n
					color="primary"
					class="text-wrap"
				>Automatically accept T&C on registration.</mat-checkbox></li>
				<li *ngIf="clusterFeaturesMask.z5JWT && appKey.provider == appKeyProviders.cognito"><mat-checkbox
					formControlName="z5JWT"
					i18n
					color="primary"
					class="text-wrap"
				>Issue Z5 JWT (not Cognito JWT).</mat-checkbox></li>
				<li *ngIf="clusterFeaturesMask.noNullNames && appKey.name.includes('Salesforce')"><mat-checkbox
					formControlName="noNullNames"
					i18n
					color="primary"
					class="text-wrap"
				>Don't return null/empty string first/last name in GET user records (e.g. salesforce).</mat-checkbox>
				</li>
				<li *ngIf="clusterFeaturesMask.loginMfaEnabled && appKey.provider == appKeyProviders.cognito"><mat-checkbox
					formControlName="loginMfaEnabled"
					i18n
					color="primary"
					class="text-wrap"
				>Enable MFA for login.</mat-checkbox></li>
				<li *ngIf="clusterFeaturesMask.loginMfaEnforced && appKey.provider == appKeyProviders.cognito"><mat-checkbox
					formControlName="loginMfaEnforced"
					i18n
					color="primary"
					class="text-wrap"
				>Enforce MFA at login.</mat-checkbox></li>
			</ul>
		</div>
		<!-- END Additional Features -->
	</div>

	<div class="row justify-content-end mb-0" *ngIf="editable">
		<div class="col" *ngIf="unsavedChanges">
			<button class="w-100" mat-flat-button (click)="cancel()" type="button">{{cancelLabel}}</button>
		</div>
		<div class="col" *ngIf="enableSuspend">
			<button
				class="w-100"
				mat-flat-button
				color="warn"
				(click)="suspendAppKey()"
				i18n
				type="button"
			>Suspend</button>
		</div>
		<div class="col">
			<button
				class="w-100"
				[disabled]="unsavedChanges && formInputs.invalid"
				type="submit"
				mat-flat-button
				color="primary"
			>
				<span i18n *ngIf="unsavedChanges">Save</span>
				<span *ngIf="!unsavedChanges">{{closeLabel}}</span>
			</button>
		</div>
	</div>

	<div mat-dialog-actions class="row justify-content-md-center mb-0" *ngIf="!editable">
		<div class="col-6">
			<button class="w-100" mat-flat-button (click)="close()" i18n type="button">Close</button>
		</div>
	</div>
</form>
